import React from "react";
import { FC } from "react";

interface IconType {
  fill?: string;
}

export const IconRWO: FC<IconType> = ({ fill = "url(#paint0_linear_217_5862)" }) => (
  <svg width="29" height="27" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.26962 5.36646C0.094934 8.70186 0.114191 10.6584 0.114191 10.6584C0.114191 10.6584 0.788203 11.0311 1.23112 11.3106C1.63552 11.5528 2.25174 12.0186 2.25174 12.0186C2.25174 12.0186 1.55848 12.1304 0.980766 12.3168C0.441564 12.4845 0.0179051 12.6149 0.0179051 12.6149C0.0179051 12.6149 -0.155405 15.559 0.576369 18.2795C1.30814 20.9627 2.19398 22.6211 2.19398 22.6211C2.19398 22.6211 3.90786 22.6584 5.33289 22.4348C6.68089 22.2298 8.06743 21.764 8.06743 21.764C8.06743 21.764 8.27925 22.9752 8.95325 24.2981C9.68503 25.7888 10.5323 27 10.5323 27C10.5323 27 12.8625 26.6646 15.4622 25.7702C18.2352 24.8199 20.4883 23.3106 20.4883 23.3106C20.4883 23.3106 20.3343 22.7329 20.1802 22.2112C20.0069 21.6522 19.718 21.0559 19.718 21.0559C19.718 21.0559 20.3343 21.2609 20.7579 21.4286C21.3934 21.6708 22.1444 22.0621 22.1444 22.0621C22.1444 22.0621 23.7813 20.9255 26.0344 18.0745C28.0564 15.5217 29 12.8944 29 12.8944C29 12.8944 25.5145 10.4721 20.5846 10.5093C16.5599 10.528 13.3632 12.1863 13.3632 12.1863C13.3632 12.1863 13.0936 8.75776 10.7442 5.36646C7.89412 1.22981 4.17746 0 4.17746 0C4.17746 0 2.50208 1.86335 1.26962 5.36646Z"
      fill={fill}
    />
    <defs>
      <linearGradient
        id="paint0_linear_217_5862"
        x1="0.00406032"
        y1="13.5243"
        x2="28.9894"
        y2="13.5243"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#64AFE2" />
        <stop offset="1" stopColor="#1B5197" />
      </linearGradient>
    </defs>
  </svg>
);

export const IconVisibilityOff: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
    <path
      d="M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z"
      fill={fill}
    />
  </svg>
);

export const IconVisibilityOn: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 7C14.76 7 17 9.24 17 12C17 12.65 16.87 13.26 16.64 13.83L19.56 16.75C21.07 15.49 22.26 13.86 22.99 12C21.26 7.61 16.99 4.5 11.99 4.5C10.59 4.5 9.25 4.75 8.01 5.2L10.17 7.36C10.74 7.13 11.35 7 12 7ZM2 4.27L4.28 6.55L4.74 7.01C3.08 8.3 1.78 10.02 1 12C2.73 16.39 7 19.5 12 19.5C13.55 19.5 15.03 19.2 16.38 18.66L16.8 19.08L19.73 22L21 20.73L3.27 3L2 4.27ZM7.53 9.8L9.08 11.35C9.03 11.56 9 11.78 9 12C9 13.66 10.34 15 12 15C12.22 15 12.44 14.97 12.65 14.92L14.2 16.47C13.53 16.8 12.79 17 12 17C9.24 17 7 14.76 7 12C7 11.21 7.2 10.47 7.53 9.8ZM11.84 9.02L14.99 12.17L15.01 12.01C15.01 10.35 13.67 9.01 12.01 9.01L11.84 9.02Z"
      fill={fill}
    />
  </svg>
);

export const IconArrowUp: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.345 17.885L22.115 16.115L12.115 6.115L2.11501 16.115L3.88501 17.885L12.115 9.655L20.345 17.885Z"
      fill={fill}
    />
  </svg>
);

export const IconArrowDown: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M3.88502 6.115L2.11502 7.885L12.115 17.885L22.115 7.88501L20.345 6.11501L12.115 14.345L3.88502 6.115Z"
      fill={fill}
    />
  </svg>
);

export const IconEdit: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z"
      fill={fill}
    />
  </svg>
);

export const IconDelete: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
      fill={fill}
    />
  </svg>
);

export const IconAdd: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill={fill} />
  </svg>
);

export const IconSave: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM19 19H5V5H16.17L19 7.83V19ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12ZM6 6H15V10H6V6Z"
      fill={fill}
    />
  </svg>
);

export const IconOpen: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V8H20V18Z"
      fill={fill}
    />
  </svg>
);

export const IconUpload: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill={fill}>
    <path
      d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z"
      fill={fill}
    />
  </svg>
);

export const IconUploadLarge: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill={fill}>
    <path
      d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z"
      fill={fill}
    />
  </svg>
);

export const IconDownload: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill={fill}>
    <path
      d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z"
      fill={fill}
    />
  </svg>
);

export const IconPartEditor: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 4C3 3.45 3.45 3 4 3H6V1H4C2.34 1 1 2.34 1 4V6H3V4Z" fill={fill} />
    <path d="M3 20V18H1V20C1 21.66 2.34 23 4 23H6V21H4C3.45 21 3 20.55 3 20Z" fill={fill} />
    <path d="M20 1H18V3H20C20.55 3 21 3.45 21 4V6H23V4C23 2.34 21.66 1 20 1Z" fill={fill} />
    <path d="M21 20C21 20.55 20.55 21 20 21H18V23H20C21.66 23 23 21.66 23 20V18H21V20Z" fill={fill} />
    <path
      d="M19 14.87V9.13C19 8.41 18.62 7.75 18 7.4L13 4.52C12.69 4.34 12.35 4.25 12 4.25C11.65 4.25 11.31 4.34 11 4.52L6 7.39C5.38 7.75 5 8.41 5 9.13V14.87C5 15.59 5.38 16.25 6 16.6L11 19.48C11.31 19.66 11.65 19.75 12 19.75C12.35 19.75 12.69 19.66 13 19.48L18 16.6C18.62 16.25 19 15.59 19 14.87ZM11 17.17L7 14.87V10.24L11 12.57V17.17ZM12 10.84L8.04 8.53L12 6.25L15.96 8.53L12 10.84ZM17 14.87L13 17.17V12.57L17 10.24V14.87Z"
      fill={fill}
    />
  </svg>
);

export const IconStorylineBuilder: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21 5C19.89 4.65 18.67 4.5 17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 20.9 1.25 21.15 1.5 21.15C1.6 21.15 1.65 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5ZM21 18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V8C13.35 7.15 15.8 6.5 17.5 6.5C18.7 6.5 19.9 6.65 21 7V18.5Z"
      fill={fill}
    />
    <path
      d="M17.5 10.5C18.38 10.5 19.23 10.59 20 10.76V9.24C19.21 9.09 18.36 9 17.5 9C15.8 9 14.26 9.29 13 9.83V11.49C14.13 10.85 15.7 10.5 17.5 10.5Z"
      fill={fill}
    />
    <path
      d="M13 12.49V14.15C14.13 13.51 15.7 13.16 17.5 13.16C18.38 13.16 19.23 13.25 20 13.42V11.9C19.21 11.75 18.36 11.66 17.5 11.66C15.8 11.66 14.26 11.96 13 12.49Z"
      fill={fill}
    />
    <path
      d="M17.5 14.33C15.8 14.33 14.26 14.62 13 15.16V16.82C14.13 16.18 15.7 15.83 17.5 15.83C18.38 15.83 19.23 15.92 20 16.09V14.57C19.21 14.41 18.36 14.33 17.5 14.33Z"
      fill={fill}
    />
  </svg>
);

export const IconMouse: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 28 28" fill="none">
    <path
      d="M2 2L9.95869 24.5267L15.4045 19.0809L22.3236 26L26 22.3236L19.0809 15.4045L24.5267 9.95869L2 2Z"
      fill={fill}
    />
  </svg>
);

export const IconMore: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
      fill={fill}
    />
  </svg>
);

export const IconDot: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 25 24" fill="none">
    <path
      d="M12.0038 8C9.79175 8 8.00375 9.788 8.00375 12C8.00375 14.212 9.79175 16 12.0038 16C14.2158 16 16.0038 14.212 16.0038 12C16.0038 9.788 14.2158 8 12.0038 8Z"
      fill={fill}
    />
  </svg>
);

export const IconArrowRight: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M6.23001 20.23L8.00001 22L18 12L8.00001 2L6.23001 3.77L14.46 12L6.23001 20.23Z" fill={fill} />
  </svg>
);

export const IconArrowLeft: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M17.51 3.87001L15.73 2.10001L5.84 12L15.74 21.9L17.51 20.13L9.38 12L17.51 3.87001Z" fill={fill} />
  </svg>
);

export const IconHamburgerMenu: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill={fill} />
  </svg>
);

export const IconHandyman: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.67 18.17L16.37 12.87H15.38L12.84 15.41V16.4L18.14 21.7C18.53 22.09 19.16 22.09 19.55 21.7L21.67 19.58C22.06 19.2 22.06 18.56 21.67 18.17ZM18.84 19.59L14.6 15.35L15.31 14.64L19.55 18.88L18.84 19.59Z"
      fill={fill}
    />

    <path
      d="M17.34 10.19L18.75 8.78L20.87 10.9C22.04 9.73 22.04 7.83 20.87 6.66L17.33 3.12L15.92 4.53V1.71L15.22 1L11.68 4.54L12.39 5.25H15.22L13.81 6.66L14.87 7.72L11.98 10.61L7.85 6.48V5.06L4.83 2.04L2 4.87L5.03 7.9H6.44L10.57 12.03L9.72 12.88H7.6L2.3 18.18C1.91 18.57 1.91 19.2 2.3 19.59L4.42 21.71C4.81 22.1 5.44 22.1 5.83 21.71L11.13 16.41V14.29L16.28 9.14L17.34 10.19ZM9.36 15.34L5.12 19.58L4.41 18.87L8.65 14.63L9.36 15.34Z"
      fill={fill}
    />
  </svg>
);

export const IconDragHandle: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M20 9H4V11H20V9ZM4 15H20V13H4V15Z" fill={fill} />
  </svg>
);

export const IconGear: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.57 5.11 19.4 5.02 19.22 5.02C19.16 5.02 19.1 5.03 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H9.99999C9.74999 2 9.53999 2.18 9.50999 2.42L9.12999 5.07C8.51999 5.32 7.95999 5.66 7.43999 6.05L4.94999 5.05C4.88999 5.03 4.82999 5.02 4.76999 5.02C4.59999 5.02 4.42999 5.11 4.33999 5.27L2.33999 8.73C2.20999 8.95 2.26999 9.22 2.45999 9.37L4.56999 11.02C4.52999 11.34 4.49999 11.67 4.49999 12C4.49999 12.33 4.52999 12.66 4.56999 12.98L2.45999 14.63C2.26999 14.78 2.21999 15.05 2.33999 15.27L4.33999 18.73C4.42999 18.89 4.59999 18.98 4.77999 18.98C4.83999 18.98 4.89999 18.97 4.94999 18.95L7.43999 17.95C7.95999 18.35 8.51999 18.68 9.12999 18.93L9.50999 21.58C9.53999 21.82 9.74999 22 9.99999 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.11 18.97 19.17 18.98 19.23 18.98C19.4 18.98 19.57 18.89 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98ZM17.45 11.27C17.49 11.58 17.5 11.79 17.5 12C17.5 12.21 17.48 12.43 17.45 12.73L17.31 13.86L18.2 14.56L19.28 15.4L18.58 16.61L17.31 16.1L16.27 15.68L15.37 16.36C14.94 16.68 14.53 16.92 14.12 17.09L13.06 17.52L12.9 18.65L12.7 20H11.3L10.95 17.52L9.88999 17.09C9.45999 16.91 9.05999 16.68 8.65999 16.38L7.74999 15.68L6.68999 16.11L5.41999 16.62L4.71999 15.41L5.79999 14.57L6.68999 13.87L6.54999 12.74C6.51999 12.43 6.49999 12.2 6.49999 12C6.49999 11.8 6.51999 11.57 6.54999 11.27L6.68999 10.14L5.79999 9.44L4.71999 8.6L5.41999 7.39L6.68999 7.9L7.72999 8.32L8.62999 7.64C9.05999 7.32 9.46999 7.08 9.87999 6.91L10.94 6.48L11.1 5.35L11.3 4H12.69L13.04 6.48L14.1 6.91C14.53 7.09 14.93 7.32 15.33 7.62L16.24 8.32L17.3 7.89L18.57 7.38L19.27 8.59L18.2 9.44L17.31 10.14L17.45 11.27ZM12 8C9.78999 8 7.99999 9.79 7.99999 12C7.99999 14.21 9.78999 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 9.99999 13.1 9.99999 12C9.99999 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z"
      fill={fill}
    />
  </svg>
);

export const IconBox: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19 14.87V9.13C19 8.41 18.62 7.75 18 7.4L13 4.52C12.69 4.34 12.35 4.25 12 4.25C11.65 4.25 11.31 4.34 11 4.52L6 7.39C5.38 7.75 5 8.41 5 9.13V14.87C5 15.59 5.38 16.25 6 16.6L11 19.48C11.31 19.66 11.65 19.75 12 19.75C12.35 19.75 12.69 19.66 13 19.48L18 16.6C18.62 16.25 19 15.59 19 14.87ZM11 17.17L7 14.87V10.24L11 12.57V17.17ZM12 10.84L8.04 8.53L12 6.25L15.96 8.53L12 10.84ZM17 14.87L13 17.17V12.57L17 10.24V14.87Z"
      fill={fill}
    />
  </svg>
);

export const IconGroup: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6 15C7.1 15 8 15.9 8 17C8 18.1 7.1 19 6 19C4.9 19 4 18.1 4 17C4 15.9 4.9 15 6 15ZM6 13C3.8 13 2 14.8 2 17C2 19.2 3.8 21 6 21C8.2 21 10 19.2 10 17C10 14.8 8.2 13 6 13ZM12 5C13.1 5 14 5.9 14 7C14 8.1 13.1 9 12 9C10.9 9 10 8.1 10 7C10 5.9 10.9 5 12 5ZM12 3C9.8 3 8 4.8 8 7C8 9.2 9.8 11 12 11C14.2 11 16 9.2 16 7C16 4.8 14.2 3 12 3ZM18 15C19.1 15 20 15.9 20 17C20 18.1 19.1 19 18 19C16.9 19 16 18.1 16 17C16 15.9 16.9 15 18 15ZM18 13C15.8 13 14 14.8 14 17C14 19.2 15.8 21 18 21C20.2 21 22 19.2 22 17C22 14.8 20.2 13 18 13Z"
      fill={fill}
    />
  </svg>
);

export const IconMesh: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.71974 6.90257L11.4996 10.1538C12.1085 10.4962 12.8519 10.4962 13.4607 10.1538L19.2406 6.90257C19.7843 6.59672 19.7843 5.81389 19.2406 5.50804L13.4607 2.25685C12.8519 1.91438 12.1085 1.91438 11.4996 2.25685L5.71974 5.50804C5.17602 5.81389 5.17602 6.59672 5.71974 6.90257ZM7.98017 6.2053L12.4802 8.7053L16.9802 6.2053L12.4802 3.7053L7.98017 6.2053Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.71974 18.0026L11.4996 21.2538C12.1085 21.5962 12.8519 21.5962 13.4607 21.2538L19.2406 18.0026C19.7843 17.6967 19.7843 16.9139 19.2406 16.6081L13.4607 13.3569C12.8519 13.0144 12.1085 13.0144 11.4996 13.3569L5.71974 16.6081C5.17602 16.9139 5.17602 17.6967 5.71974 18.0026ZM7.98017 17.3053L12.4802 19.8053L16.9802 17.3053L12.4802 14.8053L7.98017 17.3053Z"
      fill={fill}
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M13 11.1V12.4H12V11.1H13ZM13 15.7V17H12V15.7H13Z" fill={fill} />
  </svg>
);

export const IconLogout: FC<IconType> = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M17 8L15.59 9.41L17.17 11H9V13H17.17L15.59 14.58L17 16L21 12L17 8ZM5 5H12V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12V19H5V5Z"
      fill={fill}
    />
  </svg>
);

export const IconMicrosoft: FC<IconType> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
    <rect x="0" y="0" width="9" height="9" fill="#f25022" />
    <rect x="0" y="10" width="9" height="9" fill="#00a4ef" />
    <rect x="10" y="0" width="9" height="9" fill="#7fba00" />
    <rect x="10" y="10" width="9" height="9" fill="#ffb900" />
  </svg>
);

export const IconHand: FC<IconType> = ({ fill }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 24H11.45C10.37 24 9.31001 23.55 8.56001 22.77L1.26001 15.16L3.33001 13.33C3.95001 12.78 4.86001 12.67 5.59001 13.06L8.00001 14.34V4.78999C8.00001 3.40999 9.12001 2.28999 10.5 2.28999C10.67 2.28999 10.84 2.30999 11.01 2.33999C11.1 1.03999 12.18 0.00999451 13.5 0.00999451C14.36 0.00999451 15.11 0.439995 15.56 1.09999C15.85 0.979995 16.17 0.919995 16.5 0.919995C17.88 0.919995 19 2.03999 19 3.41999V3.69999C19.16 3.66999 19.33 3.64999 19.5 3.64999C20.88 3.64999 22 4.76999 22 6.14999V20C22 22.21 20.21 24 18 24ZM4.14001 15.28L10 21.38C10.38 21.77 10.9 22 11.44 22H18C19.1 22 20 21.1 20 20V6.14999C20 5.86999 19.78 5.64999 19.5 5.64999C19.22 5.64999 19 5.86999 19 6.14999V12H17V3.41999C17 3.13999 16.78 2.91999 16.5 2.91999C16.22 2.91999 16 3.13999 16 3.41999V12H14V2.50999C14 2.22999 13.78 2.00999 13.5 2.00999C13.22 2.00999 13 2.22999 13 2.50999V12H11V4.78999C11 4.50999 10.78 4.28999 10.5 4.28999C10.22 4.28999 10 4.51999 10 4.78999V17.66L4.65001 14.83L4.14001 15.28Z"
      fill={fill}
    />
  </svg>
);

export const IconRotate: FC<IconType> = ({ fill }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 13C6 11.35 6.67 9.85 7.76 8.76L6.34 7.34C4.9 8.79 4 10.79 4 13C4 17.08 7.05 20.44 11 20.93V18.91C8.17 18.43 6 15.97 6 13ZM20 13C20 8.58 16.42 5 12 5C11.94 5 11.88 5.01 11.82 5.01L12.91 3.92L11.5 2.5L8 6L11.5 9.5L12.91 8.09L11.83 7.01C11.89 7.01 11.95 7 12 7C15.31 7 18 9.69 18 13C18 15.97 15.83 18.43 13 18.91V20.93C16.95 20.44 20 17.08 20 13Z"
      fill={fill}
    />
  </svg>
);

export const IconMove: FC<IconType> = ({ fill }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 11V3H13L16.29 6.29L6.29 16.29L3 13V21H11L7.71 17.71L17.71 7.71L21 11Z" fill={fill} />
  </svg>
);
